import React from "react";
interface DashboardView {
  isSelected: boolean;
}

export const DashboardViewIcon: React.FC<DashboardView> = ({ isSelected }) => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      {isSelected ? (
        <g clipPath="url(#clip0_2034_5191)">
          <path
            d="M14.9632 0.00195312H10.1409C9.41425 0.00195312 8.8252 0.591003 8.8252 1.31763V6.13999C8.8252 6.86662 9.41425 7.45567 10.1409 7.45567H14.9632C15.6899 7.45567 16.2789 6.86662 16.2789 6.13999V1.31763C16.2789 0.591003 15.6899 0.00195312 14.9632 0.00195312Z"
            fill="#215383"
          />
          <path
            d="M6.13804 0.00195312H1.31568C0.58905 0.00195312 0 0.591003 0 1.31763V6.13999C0 6.86662 0.58905 7.45567 1.31568 7.45567H6.13804C6.86467 7.45567 7.45371 6.86662 7.45371 6.13999V1.31763C7.45371 0.591003 6.86467 0.00195312 6.13804 0.00195312Z"
            fill="#215383"
          />
          <path
            d="M14.9632 8.82715H10.1409C9.41425 8.82715 8.8252 9.4162 8.8252 10.1428V14.9652C8.8252 15.6918 9.41425 16.2809 10.1409 16.2809H14.9632C15.6899 16.2809 16.2789 15.6918 16.2789 14.9652V10.1428C16.2789 9.4162 15.6899 8.82715 14.9632 8.82715Z"
            fill="#215383"
          />
          <path
            d="M6.13804 8.82715H1.31568C0.58905 8.82715 0 9.4162 0 10.1428V14.9652C0 15.6918 0.58905 16.2809 1.31568 16.2809H6.13804C6.86467 16.2809 7.45371 15.6918 7.45371 14.9652V10.1428C7.45371 9.4162 6.86467 8.82715 6.13804 8.82715Z"
            fill="#215383"
          />
        </g>
      ) : (
        <g clipPath="url(#clip0_2034_5191)">
          <path
            d="M14.9632 0.00195312H10.1409C9.41425 0.00195312 8.8252 0.591003 8.8252 1.31763V6.13999C8.8252 6.86662 9.41425 7.45567 10.1409 7.45567H14.9632C15.6899 7.45567 16.2789 6.86662 16.2789 6.13999V1.31763C16.2789 0.591003 15.6899 0.00195312 14.9632 0.00195312Z"
            fill="#9D9D9D"
          />
          <path
            d="M6.13804 0.00195312H1.31568C0.58905 0.00195312 0 0.591003 0 1.31763V6.13999C0 6.86662 0.58905 7.45567 1.31568 7.45567H6.13804C6.86467 7.45567 7.45371 6.86662 7.45371 6.13999V1.31763C7.45371 0.591003 6.86467 0.00195312 6.13804 0.00195312Z"
            fill="#9D9D9D"
          />
          <path
            d="M14.9632 8.82715H10.1409C9.41425 8.82715 8.8252 9.4162 8.8252 10.1428V14.9652C8.8252 15.6918 9.41425 16.2809 10.1409 16.2809H14.9632C15.6899 16.2809 16.2789 15.6918 16.2789 14.9652V10.1428C16.2789 9.4162 15.6899 8.82715 14.9632 8.82715Z"
            fill="#9D9D9D"
          />
          <path
            d="M6.13804 8.82715H1.31568C0.58905 8.82715 0 9.4162 0 10.1428V14.9652C0 15.6918 0.58905 16.2809 1.31568 16.2809H6.13804C6.86467 16.2809 7.45371 15.6918 7.45371 14.9652V10.1428C7.45371 9.4162 6.86467 8.82715 6.13804 8.82715Z"
            fill="#9D9D9D"
          />
        </g>
      )}

      <defs>
        <clipPath id="clip0_2034_5191">
          <rect width="16.2791" height="16.2791" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
